export var infoItems = [
    {
        title: 'Режим работы',
        text: 'Понедельник–Пятница: с 09:00 до 21:00',
    },
    {
        title: 'Адрес',
        text: 'Семеновская пл., д7 БЦ «ВЭРОНД»\nТашкентская ул., д. 26, корп. 2, стр. 2',
    },
    {
        title: 'Телефон',
        text: '+7 499 390-64-64',
    },
    {
        title: 'Email',
        text: 'info@csio-dpo.ru',
    },
];
